import React from 'react';
import { connect } from 'react-redux';
import {
  Col,
  Row,
} from 'react-bootstrap';
import {
  Button,
  FormControl,
} from '../../../form/FormControls.jsx';
import { formatNumber } from '../elements/BaseElement';
import CurrencyInput from '@/component/form/currencyinput/index.jsx';
import { Currency } from '../../../../consts/currency.jsx';
import FancyInput from '@/component/form/numinput/index.jsx';
import RefPicker from '../../../dict/simple/select/DictPicker.jsx';
import { calcPerTon, FREIGHT_EXPENSES_TYPE, INTEREST_EXPENSES_TYPE,
  BANKING_EXPENSES_TYPE } from './ExpensesUtils';
import { handleFormChanged } from '@/store/allaround.store.js';
import { usdDefaultCurrencyRates } from '@/util/util.jsx';
import trash from '../../../../../style/trash.png';
import pt from '../../../../../style/pt.png';
import ls from '../../../../../style/ls.png';
import plusround from '../../../../../style/plusround.png';
import minusround from '../../../../../style/minusround.png';
const BLpendingMessage = 'B/L pending';

export function filterExpense(data, dealType) {
  if (data.common && dealType == 'commonPayment') {
    return true;
  }

  if (data.isSale && dealType == 'sale') {
    return true;
  }
  if (data.isPurchase && dealType == 'purchase') {
    return true;
  }
  if (data.isTransport && dealType == 'transport') {
    return true;
  }

  return false;
}

class ExpensesItemClass extends React.Component {
  constructor(props) {
    super(props);
    this.showPerTon = this.showPerTon.bind(this);
    this.setRef = this.setRef.bind(this);
    this.filterFunc = this.filterFunc.bind(this);
    this.renderLaytimeTotalExpense = this.renderLaytimeTotalExpense.bind(this);
    this.renderExpense = this.renderExpense.bind(this);
    this.state = {
      dropDownWasShown: props.data && props.data.id > 0,
    };
  }


  setRef(ref, disabled, id) {
    if (ref && !this.state.dropDownWasShown && !id) {
      this.setState({ dropDownWasShown: true });
      if (!disabled) {
        ref.focus();
      }
    }
  }

  showPerTon() {
    if (this.props.isBulkExpenseWithoutBL) {
      return BLpendingMessage;
    }
    let data = this.props.data;
    if (this.props.laytimeTotal) {
      data = this.props.laytimeTotal.get ? this.props.laytimeTotal.toJS() : this.props.laytimeTotal;
    }
    const perTon = calcPerTon(data.actual, this.props.billLandingQuantity);
    if ((perTon == undefined && this.props.billLandingQuantity == 0) || perTon == -1) {
      return BLpendingMessage;
    }
    return perTon ? formatNumber(perTon, '0,0.00') : 0.0;
  }

  filterFunc(data) {
    return filterExpense(data, this.props.dealType);
  }

  renderLaytimeTotalExpense() {
    const { laytimeTotal } = this.props;
    const showPerTon = this.showPerTon();
    return (
      <div>
        <Row
          style={{
            marginLeft: '0px',
            marginRight: '0px',
            padding: '5px',
          }}
        >
          <Col sm={5} style={{ padding: '0px' }}>
            <Col sm={2} style={{ padding: '0px 5px 0px 0px' }}>
              <Button
                id={`summtype-button-${this.props.idx}`}
                bsStyle="primary"
                style={{ width: '100%', maxWidth: '36px', height: '36px', padding: '0px' }}
                disabled
              >
                {this.props.laytimeTotal.get('isDebit')
                  ?
                  <div
                    style={{
                      fontSize: '200%',
                      top: '-4px',
                      position: 'relative',
                    }}
                  >
                    -
                  </div>
                  :
                  <div
                    style={{
                      fontSize: '200%',
                      top: '-7px',
                      position: 'relative',
                    }}
                  >
                    +
                  </div>
                }
              </Button>
            </Col>
            <Col sm={10} style={{ padding: '0px 5px 0px 0px' }}>
              <Col sm={10} style={{ padding: '0px 5px 0px 0px' }}>
                <input
                  className="form-control"
                  value="Dem/Disp"
                  type="text"
                  disabled
                />
              </Col>
              <Col sm={2} style={{ padding: '0px' }}>
                <CurrencyInput
                  name={`${this.props.prefix}-estimateCurrency`}
                  style={{ padding: '2px' }}
                  disabled
                />
              </Col>
            </Col>
          </Col>
          <Col sm={2} style={{ padding: '0px 5px 0px 5px' }}>
            <FancyInput
              className="form-control"
              style={{ textAlign: 'right' }}
              fraction={2}
              positive
              negative={false}
              thousand
              type="number"
              disabled
              name={`${this.props.prefix}-estimated`}
            />
          </Col>


          <Col sm={5} style={{ padding: '0px' }}>
            <Col sm={2} style={{ padding: '0px 5px 0px 5px' }}>
              <Button
                id={`summtype-button-${this.props.idx}`}
                bsStyle="primary"
                style={{ width: '100%', maxWidth: '36px', height: '36px', padding: '0px' }}
                disabled
              >
                LS
              </Button>
            </Col>
            <Col sm={9} style={{ padding: '0px' }}>
              <Col
                sm={5}
                style={{ paddingLeft: '0px', paddingRight: '0px' }}
              >
                <FancyInput
                  className="form-control"
                  style={{ textAlign: 'right' }}
                  fraction={2}
                  positive
                  negative={false}
                  thousand
                  value={laytimeTotal.get('actual') ? laytimeTotal.get('actual').toFixed(2) : 0}
                  type="number"
                  name={`${this.props.prefix}-actual`}
                  disabled
                />
              </Col>

              <div>
                <Col sm={2} style={{ padding: '5px 0px 0px 0px', textAlign: 'center' }}>
                  =
                </Col>
                <Col sm={5} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                  <FormControl
                    name={`${this.props.prefix}-perTon`}
                    value={showPerTon}
                    title={showPerTon}
                    style={showPerTon == BLpendingMessage ?
                      { textAlign: 'center', padding: 0 } : { textAlign: 'right' }}
                    readonly
                  />
                </Col>
              </div>
            </Col>
          </Col>
        </Row>
      </div>
    );
  }

  renderExpense() {
    const showPerTon = this.showPerTon();
    const hasTransportFreight = this.props.hasTransportFreight;
    const disabled = this.props.disabled || (!!this.props.data.expensesTypeName
      && this.props.data.expensesTypeName.toLowerCase() == FREIGHT_EXPENSES_TYPE);
    const isInterest = this.props.data.expensesTypeName
      && this.props.data.expensesTypeName.toLowerCase() == INTEREST_EXPENSES_TYPE;
    const isBanking = this.props.data.expensesTypeName
      && this.props.data.expensesTypeName.toLowerCase() == BANKING_EXPENSES_TYPE;
    const showFreightOrigin = this.props.dealType == 'sale' && this.props.data.expensesTypeName &&
    this.props.data.expensesTypeName.toLowerCase() == FREIGHT_EXPENSES_TYPE;
    const paymentExpense = this.props.data.paymentExpense || this.props.data.bulkExpense;
    const isBulkExpense = false;
    const hideDeleteButton =
      (disabled && hasTransportFreight) || paymentExpense || this.props.disabled;
    const deleteButton = hideDeleteButton ? <div /> :
      <Button
        bsStyle="link" className="link"
        onClick={() => {
          this.props.handleFormChanged();
          this.props.onDeleteRow(this.props.idx);
        }}
        style={{ padding: 0, fontSize: '13px', float: 'none' }}
      >
        <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
      </Button>;
    return (
      <div id={`expenseElement_${this.props.idx}`} className="expense-element">
        <Row
          className="expense-row"
          style={{
            marginLeft: '0px',
            marginRight: '0px',
            padding: '5px',
          }}
        >
          <input
            className="hide" type="text" name={`${this.props.prefix}-expensesIds`}
            value={this.props.data.id} readOnly
          />
          <input
            className="hide" type="text" name={`${this.props.prefix}-summType`}
            value={this.props.data.summType} readOnly
          />
          <input
            className="hide" type="text" name={`${this.props.prefix}-isDebit`}
            value={this.props.data.isDebit} readOnly
          />
          <input
            className="hide" type="text" name={`${this.props.prefix}-actualCurrency`}
            value={Currency.DOLLAR} readOnly
          />
          <input
            className="hide" type="text" name={`${this.props.prefix}-expensestype`}
            value={this.props.data.expensesType || null} readOnly
          />

          <Col sm={5} xs={7} style={{ padding: '0px' }}>
            <Col xs={2} style={{ padding: '0px 5px 0px 10px' }}>
              <Button
                id="summtypeCRDR"
                bsStyle="link"
                className="btn-link-no-underline-on-hover"
                className={'btn-round'}
                onClick={
                  () => {
                    this.props.handleFormChanged();
                    this.props
                      .onDebitChange(this.props.idx, !this.props.data.isDebit);
                  }
                }
                disabled={disabled || paymentExpense}
              >
                <div>
                  <img
                    className={'expenses-row-icon'}
                    src={this.props.data.isDebit ? minusround : plusround}
                    alt={this.props.data.isDebit ? 'DR' : 'CR'}
                  />
                </div>
              </Button>
            </Col>
            <Col xs={10} style={{ padding: '0px 5px 0px 0px' }}>
              <Col xs={10} style={{ padding: '0px 5px 0px 0px' }}>
                <RefPicker
                  dict="expensestype"
                  name={'expensestype'}
                  defaultValue={this.props.data.expensesType}
                  onChangeFunc={value => {
                    if (value && value.label
                    && value.label.toLowerCase() == BANKING_EXPENSES_TYPE) {
                      this.props.onExpensesTypeAndActualChange(this.props.idx, value, 0);
                    } else {
                      this.props.onExpensesTypeAndActualChange(this.props.idx, value);
                    }
                  }}
                  filterFunc={this.filterFunc}
                  openOnFocus
                  disabled={(disabled && hasTransportFreight) || paymentExpense
                  || this.props.disabled}
                  onRef={(ref) => this.setRef(ref, (disabled && hasTransportFreight)
                     || paymentExpense, this.props.data.expensesType)}
                  excludeData={this.props.excludeExpenseTypes}
                />
              </Col>
              <Col xs={2} style={{ padding: '0px' }}>
                <CurrencyInput
                  name={`${this.props.prefix}-estimateCurrency`}
                  style={{ padding: '2px' }}
                  onChange={value => this.props.onEstimateCurrencyChange(this.props.idx, value)}
                  defaultValue={this.props.data.estimateCurrency}
                  defaultValueRates={usdDefaultCurrencyRates(this.props.data.estimateCurrencyRates)}
                  disabled={disabled || paymentExpense}
                />
              </Col>
            </Col>
          </Col>
          {showFreightOrigin &&
            <Col sm={1} xs={2} className="freight-expense-origin">
              <RefPicker
                clearable={false}
                dict="origin"
                withEmptyValue
                name="freightOrigin"
                defaultValue={this.props.data.freightOrigin}
                onChangeFunc={value => this.props.onOriginChange(this.props.idx, value)}
              />
            </Col>
          }

          <Col sm={showFreightOrigin ? 1 : 2} xs={showFreightOrigin ? 2 : 4} style={{ padding: 0 }}>
            {isNaN(parseFloat(this.props.data.estimate)) ?
              <input
                className="form-control"
                value={this.props.data.estimate}
                type="text"
                disabled={paymentExpense || this.props.disabled
                || (this.props.dealType != 'sale' && disabled) || isBulkExpense}
              />
              :
              <FancyInput
                className="form-control"
                style={{ textAlign: 'right' }}
                fraction={2}
                positive
                negative={false}
                thousand
                type="number"
                id="estimated"
                disabled={(paymentExpense && !isInterest) || this.props.disabled
                || (this.props.dealType != 'sale' && disabled) || isBulkExpense}
                name={`${this.props.prefix}-estimated`}
                value={this.props.data.estimate}
                onChange={(e, val) => this.props.onChangeEstimated(this.props.idx, val)}
              />
            }

          </Col>


          <Col sm={5} xs={4} xsHidden style={{ padding: '0px' }}>
            <Col sm={2} xs={3} style={{ padding: '0px 5px 0 15px' }}>
              <Button
                id="summtypeLSPT"
                bsStyle="link"
                className="btn-link-no-underline-on-hover"
                className={'btn-round'}
                onClick={
                  () => {
                    this.props.handleFormChanged();
                    this.props
                      .onSummTypeChange(this.props.idx,
                        this.props.data.summType == 'LS' ? 'PT' : 'LS');
                  }
                }
                disabled={isBanking || disabled || paymentExpense}
              >
                <div>
                  <img
                    className={'expenses-row-icon'}
                    src={this.props.data.summType == 'LS' ? ls : pt}
                    alt={this.props.data.summType == 'LS' ? 'LS' : 'PT'}
                  />
                </div>
              </Button>
            </Col>
            <Col xs={9} style={{ padding: '0px' }}>
              <Col
                xs={this.props.data.summType == 'LS' ? 5 : 12}
                style={{ paddingLeft: '0px', paddingRight: '0px' }}
              >
                {(disabled || paymentExpense) && this.props.data.actual == -1 ?
                  <FormControl
                    id="actual"
                    value={BLpendingMessage}
                    title={BLpendingMessage}
                    style={{ textAlign: 'right', padding: 4 }}
                    readonly
                  />
                  :
                  <FancyInput
                    className="form-control"
                    style={{ textAlign: 'right' }}
                    fraction={2}
                    positive
                    negative={false}
                    thousand
                    type="number"
                    id="actual"
                    name={`${this.props.prefix}-actual`}
                    value={this.props.data.actual ? this.props.data.actual.toFixed(2) : 0}
                    onChange={(e, val) => this.props.onChangeActual(this.props.idx, val)}
                    disabled={isBanking || disabled || paymentExpense}
                  />
                }
              </Col>
              {this.props.data.summType == 'LS' ?
                <div>
                  <Col xs={2} style={{ padding: '5px 0px 0px 0px', textAlign: 'center' }}>
                    =
                  </Col>
                  <Col xs={5} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                    <FormControl
                      name={`${this.props.prefix}-perTon`}
                      id="perTon"
                      value={showPerTon}
                      title={showPerTon}
                      style={showPerTon == BLpendingMessage ?
                        { textAlign: 'center', padding: 0 } : { textAlign: 'right' }}
                      readonly
                    />
                  </Col>
                </div>
                :
                ''
              }
            </Col>
            <Col
              sm={1}
              xsHidden
              style={{
                paddingLeft: '0px',
                paddingRight: '0px',
                marginTop: '4px',
                textAlign: 'center',
              }}
            >{deleteButton}
            </Col>
          </Col>
          <Col
            xs={1}
            smHidden mdHidden lgHidden
            style={{
              paddingLeft: '0px',
              paddingRight: '0px',
              marginTop: '4px',
              textAlign: 'center',
            }}
          >{deleteButton}
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const { laytimeTotal } = this.props;
    if (laytimeTotal) {
      if (laytimeTotal.get('actual')) {
        return this.renderLaytimeTotalExpense();
      }
    } else {
      return this.renderExpense();
    }
    return <div />;
  }
}

ExpensesItemClass.propTypes = {
  onExpensesTypeAndActualChange: React.PropTypes.func,
  onChangeEstimated: React.PropTypes.func,
  onChangeActual: React.PropTypes.func,
  onEstimateCurrencyChange: React.PropTypes.func,
  onActualCurrencyChange: React.PropTypes.func,
  onDeleteRow: React.PropTypes.func,
  onSummTypeChange: React.PropTypes.func,
  onDebitChange: React.PropTypes.func,
  data: React.PropTypes.object,
  dealType: React.PropTypes.string,
  excludeExpenseTypes: React.PropTypes.object,
  idx: React.PropTypes.number,
  billLandingQuantity: React.PropTypes.number,
  prefix: React.PropTypes.string,
  handleFormChanged: React.PropTypes.func,
  laytimeTotal: React.PropTypes.object,
  hasTransportFreight: React.PropTypes.bool,
  isBulkExpenseWithoutBL: React.PropTypes.bool,
  disabled: React.PropTypes.bool,
  onOriginChange: React.PropTypes.func,
};

const ExpensesItem = connect(
  state => ({
    dealType: state.getIn(['allaround', 'dealType']),
  }),
  dispatch => ({
    handleFormChanged() {
      handleFormChanged(dispatch);
    },
  }),
)(ExpensesItemClass);

export const ExpensesList =
  ({
    data,
    hasTransportFreight,
    excludeExpenseTypes,
    prefix,
    billLandingQuantity,
    onExpensesTypeAndActualChange,
    onChangeEstimated,
    onChangeActual,
    onEstimateCurrencyChange,
    onActualCurrencyChange,
    onDeleteRow,
    onSummTypeChange,
    onDebitChange,
    disabled,
    onOriginChange,
  }) => (
    <div className="expenses-list">
      {data.map((expenses, idx) =>
        <ExpensesItem
          key={expenses.id || `idx-${idx}-${expenses.expensesType}-${expenses.paymentExpense}`}
          prefix={prefix}
          idx={idx}
          hasTransportFreight={hasTransportFreight}
          data={expenses}
          excludeExpenseTypes={excludeExpenseTypes}
          billLandingQuantity={billLandingQuantity}
          onExpensesTypeAndActualChange={onExpensesTypeAndActualChange}
          onChangeEstimated={onChangeEstimated}
          onChangeActual={onChangeActual}
          onEstimateCurrencyChange={onEstimateCurrencyChange}
          onActualCurrencyChange={onActualCurrencyChange}
          onDeleteRow={onDeleteRow}
          onSummTypeChange={onSummTypeChange}
          onDebitChange={onDebitChange}
          isBulkExpenseWithoutBL={expenses.isBulkExpenseWithoutBL}
          disabled={disabled}
          onOriginChange={onOriginChange}
        />,
      )}
    </div>
  );

ExpensesList.propTypes = {
  data: React.PropTypes.object,
  laytimeTotal: React.PropTypes.object,
  excludeExpenseTypes: React.PropTypes.object,
  onChangeEstimated: React.PropTypes.func,
  onChangeActual: React.PropTypes.func,
  onExpensesTypeAndActualChange: React.PropTypes.func,
  onOriginChange: React.PropTypes.func,
  onEstimateCurrencyChange: React.PropTypes.func,
  onActualCurrencyChange: React.PropTypes.func,
  onDeleteRow: React.PropTypes.func,
  onSummTypeChange: React.PropTypes.func,
  onDebitChange: React.PropTypes.func,
  billLandingQuantity: React.PropTypes.number,
  prefix: React.PropTypes.string,
  hasTransportFreight: React.PropTypes.bool,
  disabled: React.PropTypes.bool,
};

export default ExpensesList;
